import { Injectable, inject } from "@angular/core";

import { IdentityService } from "../../../../common/services/identity.service";

const debug = false;

@Injectable({ providedIn: "root" })
export class SignUpEntryService {
  private identityService = inject(IdentityService);

  isOauth = false;
  automatedTesting!: boolean;

  private _email!: string | undefined;
  private _name!: string | undefined;
  private _username!: string | undefined;
  private _orgName!: string | undefined;
  private _orgSize!: string | undefined;
  private _domain!: string | undefined;
  private _contactPhone!: string | undefined;
  private _accountType!: string | undefined;
  private _accountPlan!: string | undefined;
  private _leadSource!: string | undefined;
  private _leadType!: string | undefined;

  private _verificationToken: string | undefined;
  private _cookie: any;
  private _oauthToken: string | undefined;
  private _oAuthServiceUserId: string | undefined;
  private _oAuthService: string | undefined;

  constructor() {
    this.init();
  }

  private init(): void {
    debug &&
      this.identityService.state.subscribe(state => console.warn("Onboarding App State", state));

    this.getTokenOrCookie();
    if (this.automatedTesting) {
      return;
    }
    this.isOauth = !!this._cookie;
  }

  private getTokenOrCookie(): void {
    const params = new URLSearchParams(document.location.search.substring(1));
    const token = params.get("signup");

    const name = "onsipSignup";
    const cookie = document.cookie.match(new RegExp(name + "=([^;]+)"));

    const testing = params.get("automatedTesting");
    this.automatedTesting = !!testing && testing === "true";

    if (token) {
      const data = JSON.parse(atob(token));
      this._email = data.ContactEmail;
      this._name = data.ContactName;
      this._username = data.ContactName.split(" ")[0].toLowerCase();
      this._orgName = data.OrganizationName;
      this._orgSize = data.OrganizationSize;
      this._domain = data.OrganizationName.toLowerCase();
      this._contactPhone = data.ContactPhone || "";
      this._accountType = data.AccountType;
      this._accountPlan = data.AccountPlan;
      this._leadSource = data.LeadSource;
      this._leadType = data.LeadType;
      this._verificationToken = data.VerificationToken;
    } else if (cookie) {
      const data = JSON.parse(decodeURI(cookie[1]));
      this._email = data.e;
      this._name = data.n;
      this._username = data.n.split(" ")[0].toLowerCase();
      this._orgName = data.o;
      this._domain = data.o.toLowerCase();
      this._contactPhone = data.ph;
      this._accountType = data.ty;
      this._accountPlan = data.pl;
      this._oauthToken = data.t;
      this._oAuthServiceUserId = data.u;
      this._oAuthService = data.s;
      this._cookie = data;
    }
  }

  get email(): string | undefined {
    return this._email;
  }
  get name(): string | undefined {
    return this._name;
  }
  get username(): string | undefined {
    return this._username;
  }
  get orgName(): string | undefined {
    return this._orgName;
  }
  get orgSize(): string | undefined {
    return this._orgSize;
  }
  get domain(): string | undefined {
    return this._domain;
  }
  get contactPhone(): string | undefined {
    return this._contactPhone;
  }
  get accountType(): string | undefined {
    return this._accountType;
  }
  get accountPlan(): string | undefined {
    return this._accountPlan;
  }
  get leadSource(): string | undefined {
    return this._leadSource;
  }
  get leadType(): string | undefined {
    return this._leadType;
  }
  get verificationToken(): string | undefined {
    return this._verificationToken;
  }
  get cookie(): string | undefined {
    return this._cookie;
  }
  get oauthToken(): string | undefined {
    return this._oauthToken;
  }
  get oAuthServiceUserId(): string | undefined {
    return this._oAuthServiceUserId;
  }
  get oAuthService(): string | undefined {
    return this._oAuthService;
  }
}
